export enum AccessLevel {
    Public = "public",
    Admin = "admin",
    Moderator = "moderator"
    // Custom roles will be handled dynamically
}

export interface CustomRole {
    id: string;
    name: string;
    description?: string;
    isSystem: boolean;
    isActive: boolean;
}
